import { cn } from "@/lib/cn";
import type { HTMLAttributes } from "react";

type InlineErrorTone = "danger" | "success" | "info";

interface InlineErrorProps extends HTMLAttributes<HTMLParagraphElement> {
  message: string;
  tone?: InlineErrorTone;
}

const toneClasses: Record<InlineErrorTone, string> = {
  danger: "border-[var(--color-danger)]/30 bg-[var(--color-danger)]/10 text-[var(--color-danger)]",
  success:
    "border-[var(--color-success)]/30 bg-[var(--color-success)]/10 text-[var(--color-success)]",
  info: "border-[var(--color-info)]/30 bg-[var(--color-info)]/10 text-[var(--color-info)]",
};

/** Tokened banner for inline errors and statuses. Matches DataTable / Explore error banner styling. */
export function InlineError({ message, tone = "danger", className, ...props }: InlineErrorProps) {
  return (
    <p
      role="alert"
      className={cn("rounded-lg border px-4 py-3 text-sm", toneClasses[tone], className)}
      {...props}
    >
      {message}
    </p>
  );
}
